import * as LoggingRules from '../../_constants/logging_rules';

function logDispatch(action, payload) {
    if (LoggingRules.LOG_DISPATCH) {
        log("Dispatching:", action, payload);
    }
}

function logGoogleAnalyticsEvent(gaAction, gaActionType, gaActionData) {
    if (LoggingRules.LOG_GOOGLE_ANALYTICS) {
        log("Google Analytics:", gaAction, gaActionType, JSON.stringify(gaActionData));
    }
}

function logFunnelAnalyticsEvent(action, actionType, actionData) {
    if (LoggingRules.LOG_FUNNEL_ANALYTICS) {
        log("Funnel Analytics:", action, actionType, JSON.stringify(actionData));
    }
}

const log = (...args) => {
    if (typeof __DEV__ !== 'undefined' && __DEV__) {
        console.log(...args);
    }
};

export {
    logDispatch,
    logGoogleAnalyticsEvent,
    logFunnelAnalyticsEvent
};
